import React, { useState } from "react";
import { Button, Heading } from "@americanexpress/dls-react";
import "./ThankYouStyle.css";
import Header from "../Header/Header";
import TickIcon from "../../assets/thankyou.svg";
import CheckIcon from "../../assets/checkbox.svg";
import one from "../../assets/Group 363.svg";
import two from "../../assets/Group 386.svg";
import three from "../../assets/Group 411.svg";
import Timer from "../Timer/Timer";
import { useTranslation } from "react-i18next";

const ThankYou = (props) => {
  const [usersmain] = useState(props.location.state[0]);
  const [trid] = useState(props.location.state[5]);
  const [i] = useState(0);

  const onSubmit = () => {
    props.history.push("/");
  };

  const { t, i18n } = useTranslation("common");
  i18n.changeLanguage(localStorage.getItem("lang"));
  const modifyUser = props.history.location.state[6];

  return (
    <>
      <Header />
      <div className="confheader">
        <div className="heading">
          <div className="step">
            <div className="step-counter">
              <img src={one} alt="step1" />{" "}
              <span className="active">{t("newuser.userdetails")}</span>
            </div>
            <div className="step-counter">
              <img src={two} alt="step2" />
              <span className="active">{t("access.approval")}</span>
            </div>
            <div className="step-counter">
              <img src={three} alt="step3" />
              <span className="active">{t("confirm.confirmdetails")}</span>
            </div>
          </div>
          <div className="timer">
            <Timer time={"0"} hist={props.history} />
          </div>
        </div>
      </div>

      <div id="thank-you-page" className="thankYouPage mainBody">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-xs-12">
              <div className="successBox">
                <div>
                  <img src={TickIcon} alt="successicon" />
                </div>

                <Heading level={5} className={"thankYouTitle"}>
                  {modifyUser
                    ? t("thankYou.modifyUserThankYouMsg")
                    : t("thankYou.newUserThankYouMsg")}
                </Heading>

                <Heading
                  level={4}
                  className={"heading-4 dls-deep-blue pad-1-b"}
                >
                  {t("thankYou.userTransactionId")} <b>{trid}</b>
                </Heading>

                <div className="information">{t("thankYou.request")}</div>
              </div>
            </div>
          </div>
        </div>

        {usersmain.length > 0 && (
          <div className="userInfoBox">
            {usersmain.map((user) => {
              let arr = [];
              let listItems = [];
              let isAPACAndUKAccess = false; //This will set to true when you select APAC and UK countries of access in self enrollment
              let ukCountryAccessLength = 0;
              let isOtherCountryAccess = false;

              return (
                <div className="container">
                  <div className="row line" key={usersmain.indexOf(user)}>
                    <div className="col-md-6 col-xs-12">
                      <Heading
                        level={4}
                        className={"heading-4 dls-deep-blue pad-1-b pad-2-t"}
                      >
                        {modifyUser
                          ? t("confirm.modifyPAHeading")
                          : t("confirm.newPAHeading")}{" "}
                        {usersmain.indexOf(user) + 1}
                      </Heading>

                      <div className="userdata">
                        <table>
                          <tbody>
                            {i18n.language === "en" ? (
                              <>
                                <tr>
                                  <td className="labelName">
                                    {t("newuser.fn")}:
                                  </td>
                                  <td className="labelValue">
                                    {user.firstName}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="labelName">
                                    {t("newuser.ln")}:
                                  </td>
                                  <td className="labelValue">
                                    {user.lastName}
                                  </td>
                                </tr>
                              </>
                            ) : (
                              <>
                                <tr>
                                  <td className="labelName">
                                    {t("newuser.ln")}:
                                  </td>
                                  <td className="labelValue">
                                    {user.lastName}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="labelName">
                                    {t("newuser.fn")}:
                                  </td>
                                  <td className="labelValue">
                                    {user.firstName}
                                  </td>
                                </tr>
                              </>
                            )}
                            {user.phoneNumber !== "" && (
                              <tr>
                                <td className="labelName">
                                  {usersmain[usersmain.indexOf(user)]
                                    .country === t("access.UNITEDKINGDOM")
                                    ? t("common.TelephoneNumber")
                                    : t("confirm.phno")}
                                  :
                                </td>
                                <td className="labelValue">
                                  {user.phoneNumber}
                                </td>
                              </tr>
                            )}
                            <tr>
                              <td className="labelName">
                                {usersmain[usersmain.indexOf(user)].country ===
                                  t("access.UNITEDKINGDOM")
                                  ? t("common.EmailAddress")
                                  : t("confirm.businessemail")}
                                :
                              </td>
                              <td className="labelValue">{user.emailId}</td>
                            </tr>
                            {!modifyUser && user.country && (
                              <tr>
                                <td className="labelName">
                                  {t("confirm.country")}:
                                </td>
                                <td className="labelValue">{user.country}</td>
                              </tr>
                            )}
                            {!modifyUser && user.verificationPin && (
                              <tr>
                                <td className="labelName">Verification Pin:</td>
                                <td className="labelValue">
                                  {user.verificationPin}
                                </td>
                              </tr>
                            )}
                            {!modifyUser &&
                              (user.country !== "Australia" ||
                                (user.country !== "Japan" &&
                                  user.verificationWord && (
                                    <tr>
                                      <td className="labelName">
                                        {t("newuser.vword")}:
                                      </td>
                                      <td className="labelValue">
                                        {user.verificationWord}
                                      </td>
                                    </tr>
                                  )))}
                          </tbody>
                        </table>
                      </div>

                      <div className="pad-1-t pad-1-b">
                        <hr />
                      </div>
                      {user.access?.map((acc) => (
                        <>
                          <Heading
                            level={4}
                            className={"heading-4 dls-deep-blue pad-1-b"}
                          >
                            <>
                              {t("newuser.access")}{" "}
                              {user.access.indexOf(acc) + 1}
                            </>
                          </Heading>

                          <div className="access">
                            <table>
                              <tbody>
                                <tr>
                                  <td className="labelName">
                                    {t("confirm.country")}:
                                  </td>
                                  <td className="labelValue">{acc.country}</td>
                                </tr>
                                <tr>
                                  <td className="labelName">
                                    {t("confirm.controlacno")}:
                                  </td>
                                  <td className="labelValue">
                                    {acc.controlAccountNumber}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="labelName">
                                    {t("confirm.function")}:
                                  </td>
                                  <td className="labelValue">
                                    {acc.functions.map((funct) => (
                                      <p>{funct.functionName}</p>
                                    ))}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="labelName rolesLabel">
                                    {acc.functions.map((funct) => (
                                      <>
                                        {funct.roles.length > 0 && (
                                          <b>Roles:</b>
                                        )}
                                      </>
                                    ))}
                                  </td>
                                  <td className="labelValue">
                                    {acc.functions.map((funct) => (
                                      <>
                                        {funct.roles.length > 0 && (
                                          <>
                                            {funct.roles.map((rol) => (
                                              <>
                                                {rol.roleName && (
                                                  <p>{rol.roleName}</p>
                                                )}
                                              </>
                                            ))}
                                          </>
                                        )}
                                      </>
                                    ))}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </>
                      ))}
                    </div>

                    <div className="col-md-6 col-xs-12">
                      <Heading
                        level={4}
                        className={"heading-4 dls-deep-blue pad-2-t"}
                      >
                        {i18n.language === "en" && (
                          <>
                            {t("confirm.useraccess")}{" "}
                            {usersmain.indexOf(user) + 1}
                          </>
                        )}
                      </Heading>
                      {user.access?.length > 1 &&
                        user.access.map((acc) => {
                          if (acc.country === t("access.UNITEDKINGDOM")) {
                            ukCountryAccessLength++;
                          }
                          if (acc.country !== t("access.UNITEDKINGDOM")) {
                            isOtherCountryAccess = true;
                          }
                          if (
                            ukCountryAccessLength > 1 &&
                            isOtherCountryAccess === false
                          ) {
                            isAPACAndUKAccess = false;
                          }
                          if (
                            ukCountryAccessLength > 0 &&
                            isOtherCountryAccess === true
                          ) {
                            isAPACAndUKAccess = true;
                          }
                        })}
                      {user.selfenroll === "1" && !isAPACAndUKAccess && user.authorizedSignatories?.length === 1 ? (
                        <>
                          <Heading
                            level={4}
                            className={
                              "heading-4 dls-deep-blue pad-1-b pad-1-t"
                            }
                          >
                            {i18n.language === "en" && (
                              <>{t("confirm.selfindv")}</>
                            )}
                          </Heading>

                          <h4 className="confirm">
                            {t("confirm.signatory")}{" "}
                            {/* {user.access?.length > 0 && (
                              <>
                                {user.access.map((cntry) => {
                                  if (arr.indexOf(cntry.country) === -1) {
                                    arr.push(cntry.country);
                                  }
                                  listItems = arr;
                                })}
                                {listItems.map((item) => (
                                  <span>({item})</span>
                                ))}
                              </>
                            )} */}
                            {user.authorizedSignatories?.map((auth) =>
                              auth?.country?.map((cntry) => {
                                if (arr.indexOf(cntry) === -1) {
                                  arr.push(cntry);
                                }
                                listItems = arr;
                                const countryLabel = typeof cntry === "string" ? cntry : cntry?.country;
                                return <span>({countryLabel})</span>;
                              })
                            )}
                          </h4>

                          <table>
                            <tbody>
                              <tr>
                                <td className="labelName">
                                  {t("confirm.name")}:
                                </td>
                                <td className="labelValue">
                                  {i18n.language === "en"
                                    ? `${user.authorizedSignatories[i].firstName} ${user.authorizedSignatories[i].lastName}`
                                    : `${user.authorizedSignatories[i].lastName} ${user.authorizedSignatories[i].firstName}`}
                                </td>
                              </tr>
                              <tr>
                                <td className="labelName">
                                  {usersmain[usersmain.indexOf(user)]
                                    .country === t("access.UNITEDKINGDOM")
                                    ? t("common.TelephoneNumber")
                                    : t("confirm.phno")}
                                  :
                                </td>
                                <td className="labelValue">
                                  {user.authorizedSignatories[i].phoneNumber}
                                </td>
                              </tr>
                              <tr>
                                <td className="labelName">
                                  {usersmain[usersmain.indexOf(user)]
                                    .country === t("access.UNITEDKINGDOM")
                                    ? t("common.EmailAddress")
                                    : t("confirm.businessemail")}
                                  :
                                </td>
                                <td className="labelValue">
                                  {user.authorizedSignatories[i].emailId}
                                </td>
                              </tr>
                              <tr>
                                <td className="labelName">
                                  {t("newuser.position")}:
                                </td>
                                <td className="labelValue">
                                  {user.authorizedSignatories[i].position}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <h5 className="confirm">
                            <b>{t("confirm.t&c")}</b>
                          </h5>
                          <img src={CheckIcon} alt="icon" />
                          <span>
                            {i18n.language === "en"
                              ? ` ${user.authorizedSignatories[i].firstName}  ${user.authorizedSignatories[i].lastName}`
                              : ` ${user.authorizedSignatories[i].lastName}  ${user.authorizedSignatories[i].firstName}`}
                            <b>{t("confirm.agree-t&c")}</b>
                          </span>
                        </>
                      ) : (
                        <>
                          {+user.authorizedSignatoriesCount > 1 ? (
                            <>
                              {user.selfenroll === "1" && (
                                <Heading
                                  level={4}
                                  className={"heading-4 dls-deep-blue pad-1-t"}
                                >
                                  {i18n.language === "en" && (
                                    <>{t("confirm.selfindv")}</>
                                  )}
                                </Heading>
                              )}
                              {user.authorizedSignatories?.map((auth, authIdx) => {
                                if (authIdx >= +user.authorizedSignatoriesCount) return null;
                                return (
                                <>
                                  {i18n.language === "jap" && (
                                    <h4
                                      style={{
                                        color: "#006FCF",
                                      }}
                                    >
                                      <b>
                                        {t("confirm.useraccess1")}{" "}
                                        {usersmain.indexOf(user) + 1}
                                        {t("confirm.useraccess2")}{" "}
                                        {user.authorizedSignatories.indexOf(
                                          auth
                                        ) + 1}
                                      </b>
                                    </h4>
                                  )}
                                  <h4 className="authheading">
                                    {t("confirm.signatory")}{" "}
                              {user.selfenroll === "1"
                                        ? auth?.country?.map((cntry) => {
                                            if (arr.indexOf(cntry) === -1) {
                                              arr.push(cntry);
                                            }
                                            listItems = arr;
                                            const countryLabel = typeof cntry === "string" ? cntry : cntry?.country;
                                            return <span>({countryLabel})</span>;
                                          })
                                        : auth?.country?.length > 0 &&
                                          auth?.country?.map((counauth) => {
                                            const countryLabel = typeof counauth === "string" ? counauth : counauth?.country;
                                            return <span>({countryLabel})</span>;
                                          })}
                                  </h4>
                                  <table>
                                    <tbody>
                                      <tr>
                                        <td className="labelName">
                                          {t("confirm.name")}:
                                        </td>
                                        <td className="labelValue">
                                          {i18n.language === "en"
                                            ? `${auth.firstName} ${auth.lastName}`
                                            : `${auth.lastName} ${auth.firstName}`}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="labelName">
                                          {t("confirm.phno")}:
                                        </td>
                                        <td className="labelValue">
                                          {auth.phoneNumber}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="labelName">
                                          {t("newuser.email")}:
                                        </td>
                                        <td className="labelValue">
                                          {auth.emailId}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="labelName">
                                          {t("newuser.position")}:
                                        </td>
                                        <td className="labelValue">
                                          {auth.position}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  <h5 className="confirm">
                                    <b>{t("confirm.t&c")}</b>
                                  </h5>
                                  <img src={CheckIcon} alt="icon" />
                                   <span>
                                    {i18n.language === "en"
                                      ? ` ${auth.firstName} ${auth.lastName}`
                                      : ` ${auth.lastName} ${auth.firstName}`}
                                    <b> {t("confirm.agree-t&c")}</b>
                                  </span>
                                </>
                              ); })}
                            </>
                          ) : (
                            <>
                              {user.authorizedSignatories?.map((auth, authIdx) => {
                                if (authIdx >= +user.authorizedSignatoriesCount) return null;
                                return (
                                <>
                                  <h4 className="authheading">
                                    {t("confirm.signatory")}{" "}
                                    {auth.country?.length > 0 &&
                                      auth.country.map((counauth) => {
                                        const countryLabel = typeof counauth === "string" ? counauth : counauth?.country;
                                        return <span>({countryLabel})</span>;
                                      })}
                                  </h4>
                                  <table>
                                    <tbody>
                                      <tr>
                                        <td className="labelName">
                                          {t("confirm.name")}:
                                        </td>
                                        <td className="labelValue">
                                          {i18n.language === "en"
                                            ? `${auth.firstName} ${auth.lastName}`
                                            : `${auth.lastName} ${auth.firstName}`}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="labelName">
                                          {t("confirm.phno")}:
                                        </td>
                                        <td className="labelValue">
                                          {auth.phoneNumber}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="labelName">
                                          {t("newuser.email")}:
                                        </td>
                                        <td className="labelValue">
                                          {auth.emailId}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="labelName">
                                          {t("newuser.position")}:
                                        </td>
                                        <td className="labelValue">
                                          {auth.position}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <h5 className="confirm">
                                    <b>{t("confirm.t&c")}</b>
                                  </h5>
                                  <img src={CheckIcon} alt="icon" />
                                   <span>
                                    {i18n.language === "en"
                                      ? ` ${auth.firstName} ${auth.lastName}`
                                      : ` ${auth.lastName} ${auth.firstName}`}
                                    <b> {t("confirm.agree-t&c")}</b>
                                  </span>
                                </>
                              ); })}
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div className="buttonSection">
          <div className="container">
            <div className="row">
              <div className="col-xs-12">
                <div className="float-right">
                  <a
                    href={`data:application/pdf;base64,${props.location.state[4]}`}
                    download={`American Express @ Work®.pdf`}
                    className="PDFbutton"
                  >
                    <Button styleType="primary"> {t("thankYou.print")}</Button>
                  </a>

                  <Button styleType="primary" onClick={onSubmit}>
                    {t("confirm.goToHome")}
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bottomLine"></div>
      </div>
    </>
  );
};

export default ThankYou;
